/**
 * ErrorBoundary, zachytí chybu při vykreslování a místo bílé obrazovky
 * ukáže přátelskou hlášku. Chybu zaloguje do konzole pro ladění.
 */
import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || 'Neznámá chyba' };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary zachytil chybu:', error, info);
  }

  reset = () => this.setState({ hasError: false, message: '' });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ maxWidth: 560, margin: '2rem auto', padding: '2rem 1.5rem', textAlign: 'center', fontFamily: "'Inter', sans-serif" }}>
        <h3 style={{ color: 'var(--star-white)', margin: '0 0 0.5rem' }}>Něco se nepodařilo zobrazit</h3>
        <p style={{ color: 'var(--text-dim)', lineHeight: 1.55, marginBottom: '1.25rem' }}>
          Omlouváme se, při zobrazení této části došlo k chybě. Vaše data jsou v pořádku uložená.
          Zkuste to prosím znovu, nebo nám napište přes Konzultaci.
        </p>
        <button
          onClick={() => { this.reset(); if (this.props.onReset) this.props.onReset(); }}
          style={{ background: 'var(--purple-glow)', color: 'white', border: 'none', borderRadius: 8, padding: '0.6rem 1.4rem', fontWeight: 700, cursor: 'pointer' }}
        >
          Zkusit znovu
        </button>
      </div>
    );
  }
}
